import { render, staticRenderFns } from "./DGroup.vue?vue&type=template&id=99e651e2&"
import script from "./DGroup.vue?vue&type=script&lang=js&"
export * from "./DGroup.vue?vue&type=script&lang=js&"
import style0 from "./DGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99e651e2')) {
      api.createRecord('99e651e2', component.options)
    } else {
      api.reload('99e651e2', component.options)
    }
    module.hot.accept("./DGroup.vue?vue&type=template&id=99e651e2&", function () {
      api.rerender('99e651e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DesignEditor/component/operation/DGroup.vue"
export default component.exports